export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50 scroll-mt-header">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
              <i className="ri-smartphone-line"></i>
              <span>移动端阅读更便捷</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">随时随地，畅享漫画</h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              漫蛙漫画网完美适配手机和平板，无需下载App即可享受流畅的移动端阅读体验。
              高清画质自适应屏幕，离线也能接着看，让漫画随时随地陪伴你。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-xl cursor-pointer whitespace-nowrap">
                <i className="ri-apple-fill text-lg"></i>
                <span className="text-sm font-medium">App Store</span>
              </div>
              <div className="flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-xl cursor-pointer whitespace-nowrap">
                <i className="ri-android-fill text-lg"></i>
                <span className="text-sm font-medium">Google Play</span>
              </div>
              <div className="flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-700 border border-background-200/70 rounded-xl cursor-pointer whitespace-nowrap">
                <i className="ri-qr-code-line text-lg"></i>
                <span className="text-sm font-medium">扫码直达</span>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-56 h-56 md:w-64 md:h-64 rounded-3xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20displaying%20colorful%20manga%20reading%20app%20interface%2C%20comic%20pages%20visible%20on%20screen%2C%20warm%20coral%20and%20orange%20UI%20theme%2C%20clean%20modern%20design%2C%20soft%20lighting%2C%20minimal%20background%2C%20digital%20illustration%20style&width=512&height=512&seq=app-phone-01&orientation=squarish"
                alt="漫蛙漫画移动端阅读界面"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}